// NOTE: This will be overridden in app -> provider level (for example: FieldMissionProvider and its components) as this relies to regionalized urls after selecting a project in app level (C3D) OR adding custom params in tcRegion/tcProjectId (Mapviewer)

export const DEFAULT_FEATURES_SERVICE_URLS = {
  featuresApi:
    'https://cloud.stage.api.trimblecloud.com/Features-Service/features-na/1.0/',
  tilesApi: 'https://na.stage.tiles.maps.trimblegeospatial.com', //TODO: Update this if cloud domain name for tilesApi is available in infrastructure level - https://jira.trimble.tools/browse/GCC-342
} as const;
